module.exports = __webpack_public_path__ + "img/howItWorks.1ba7a1d0.png";